import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface KnowledgebaseViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class KnowledgebaseViewPage extends Component<KnowledgebaseViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.knowledgebase.view }}
                pages={{
                    entity: InferenceEntities.knowledgebase(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}